<template>
    <div class="settings-users-create">

        <!-- Título da página -->
        <mu-title color="secondary" textStrong="700">Editar Usuário</mu-title>

        <!-- Breadcrumbs -->
        <mu-breadcrumbs divider="—">
            <font-awesome-icon icon="chevron-right" slot="divider" class="icon-sm icon-margin-right"/>
            <mu-breadcrumbs-item v-for="item in breadcrumbs" :key="item.text" :to="{ name: item.route }" :disabled="item.disabled">{{ item.text }}</mu-breadcrumbs-item>
        </mu-breadcrumbs>

        <!-- Formulário de cadastro/edição -->
        <mu-form-user type="edit"></mu-form-user>

    </div>
</template>

<script>
    export default {
        name: 'app-settings-users-create',
        data () {
            return {
                breadcrumbs: [
                    {
                        text: 'Configurações',
                        route: 'app.settings',
                        disabled: false
                    },
                    {
                        text: 'Usuários',
                        route: 'app.settings.users',
                        disabled: false
                    },
                    {
                        text: 'Editar Usuário',
                        disabled: true
                    }
                ]
            }
        }
    }
</script>
